module.exports = __webpack_public_path__ + "static/media/gastro-main-2.3d5e64ef.jpg";